<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'PassThrough'
}
</script>



// WEBPACK FOOTER //
// src/common/components/PassThrough.vue